import type { Direction } from "../direction";
import { Event } from "../events/event";
import { EventType } from "../events/eventType";
import type { ProjectileHittable, SomethingWithState, Bumpable, Interactable } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export enum TerminalState {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	NO_POWER = "NO_POWER",
}

export abstract class Terminal
	extends PhysicalThing
	implements ProjectileHittable, SomethingWithState, Bumpable, Interactable
{
	protected state: TerminalState = TerminalState.ACTIVE;

	constructor(xy: XY) {
		super(xy, true);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.METAL_BANG, this.xy));
	}

	isHittable(): boolean {
		return true;
	}

	canInteract(): boolean {
		return this.state === TerminalState.ACTIVE || this.state === TerminalState.NO_POWER;
	}

	interact(_player: PhysicalThing): void {
		if (this.state === TerminalState.NO_POWER) {
			const board = this.board!;
			board.addNonPhysicalThing(new Sound(SoundId.TERMINAL_ERROR, this.xy));
			board.addEvent(new Event(EventType.TERMINAL_NO_POWER));
			return;
		}
		this.runTerminalAction();
		this.state = TerminalState.INACTIVE;
	}

	bump(_direction: Direction, author: PhysicalThing): boolean {
		if (!this.canInteract()) return false;
		this.interact(author);
		return true;
	}

	getState(): TerminalState {
		return this.state;
	}

	setState(state: TerminalState): void {
		this.state = state;
	}

	abstract runTerminalAction(): void;
}
